import { journeyAction, } from './base';

import { JourneyActionStartMailOutbound as JourneyActionStartMailBase, } from 'atlas-shared';

export const JourneyActionStartMailOutbound = journeyAction({
  ...JourneyActionStartMailBase,
  icon: 'Mail',
});
